import { render, staticRenderFns } from "./ModalAddBundle.vue?vue&type=template&id=57ffa496"
import script from "./ModalAddBundle.vue?vue&type=script&lang=js"
export * from "./ModalAddBundle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports